import React from "react";

const sizes = {
  xs: "text-[10px] font-normal leading-[14px]",
  lg: "text-sm font-normal leading-[17px]",
  s: "text-xs font-medium leading-[100%]",
  "2xl": "text-[22px] font-medium",
  xl: "text-base font-normal leading-5",
  md: "text-[13px] font-normal leading-4",
};

const Text = ({ children, className = "", as, size = "lg", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`text-gray-700 font-inter ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
